<div class="campaign-option--live">
  <div class="campaign-option__container">
    <img class="campaign-option__image campaign-option__image--live" [src]="getImageUrl()" />
    <div class="campaign-option__info--live">
      <div class="campaign-option__name campaign-option__name--live">{{ option.name }}</div>
      <div class="min-step">
        <div class="min-step__label text-truncate">Pledge</div>
        <div class="min-step__value text-truncate">{{ option.amount | currency:'USD':'symbol-narrow':'1.0-0' }}</div>
      </div>
    </div>
  </div>
</div>
<div class="widget__separator"></div>
<div class="d-flex justify-content-end campaign-option__leader">
  <div *ngIf="winner" class="d-flex align-items-center campaign-option__leader-info w-100">
    <app-icon-success></app-icon-success>
    <div class="campaign-option__leader-name">{{winner.name}}</div>
    <div class="campaign-option__leader-text">is Winner</div>
  </div>
  <button
    class="btn btn--paybee btn--success btn--sm btn--declare-leader"
    (click)="declareLastHero()"
    [disabled]="status"
  >{{buttonLabel}}</button>
</div>